<div class="account">
    <ul class="accountmenu">
        <li (click)="navigateTo('/user/profile')">My Profile
            <span class="fa fa-user" aria-hidden="true"></span>
        </li>
        @if(isApplicant() && hasActiveApplication()){
        <li (click)="navigateTo('/uploads')">Uploads
            <span class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></span>
        </li>
        }
        <li (click)="navigateTo('/messages')">Messages
            <span class="fa-regular fa-envelope" aria-hidden="true"></span>
        </li>
        @if(isApplicant()) {
        <li class="separator"></li>
        <li (click)="navigateTo('/user/terms-and-conditions/latest/agreed')">Terms &amp; Conditions<span
                class="fa-solid fa-handshake" aria-hidden="true"></span></li>
        <li (click)="navigateTo('/medical/pre-existing-conditions')">Pre-existing medical conditions<span
                class="fa-solid fa-notes-medical" aria-hidden="true"></span></li>
        <li (click)="navigateTo('/privacy-policy')">Privacy Policy
            <span class="fa fa-user-secret" aria-hidden="true"></span>
        </li>
        }
        <li class="separator"></li>
        <li (click)="signOut()">Sign Out
            <span class="fa-solid fa-arrow-right-from-bracket" aria-hidden="true"></span>
        </li>
    </ul>
</div>
